<template>
  <v-container fluid class="px-0">
    <v-card class="mb-4" v-if="!loadDefault">
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="4">
            Paieška
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <form @keydown.enter.prevent="submit()">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="3">
              <el-checkbox
                class="mt-2 mb-2 ml-0"
                label="Mano darbai"
                v-model="extraData.mano_darbai"
              />
            </v-col>
          </v-row>

          <v-expansion-panels
            v-model="searchPanel"
            :class="isExpanded ? `mb-4` : `mb-4 mt-3`"
            :flat="isExpanded"
            v-if="!loadDefault"
          >
            <v-expansion-panel>
              <v-expansion-panel-header :class="isExpanded ? `pa-0` : ``">
                <v-row no-gutters>
                  <v-col cols="4">
                    Išplėstinė paieška
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="expansion-panel-no-padding">
                <v-row class="mb-3">
                  <v-col cols="12" md="4">
                    <el-autocomplete
                      :items="paieskaTipasList"
                      itemvalue="value"
                      itemtext="text"
                      label="Paslaugos pavadinimas"
                      tooltip="Paieška. Savitarnos paieškos. Paieškos pavadinimas"
                      v-model="extraData.pai_tipas"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <el-text-field
                      label="Užsakymo numeris"
                      tooltip="Paieška. Savitarnos paieškos. Paieškos numeris"
                      v-model="extraData.pai_numeris"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <el-autocomplete
                      :items="paieskaBusenaList"
                      itemvalue="value"
                      itemtext="text"
                      multiple
                      label="Būsena"
                      tooltip="Paieška. Savitarnos paieškos. Paieškos būsena"
                      v-model="extraData.pai_busenos"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <el-autocomplete
                      :items="paieskaApimtisList"
                      itemvalue="value"
                      itemtext="text"
                      label="Apimtis"
                      tooltip="Paieška. Savitarnos paieškos. Apimtis"
                      v-model="extraData.pai_apimtis"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <el-text-field
                      label="Užsakęs asmuo"
                      tooltip="Paieška. Savitarnos paieškos. Paiešką užsakęs asmuo"
                      v-model="extraData.pai_sukure"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <el-date-picker
                      label="Užsakymo data nuo"
                      tooltip="Paieška. Savitarnos paieškos. Paieškos data nuo"
                      v-model="extraData.pai_sukurimo_data_nuo"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <el-date-picker
                      label="Užsakymo data iki"
                      tooltip="Paieška. Savitarnos paieškos. Paieškos data iki"
                      v-model="extraData.pai_sukurimo_data_iki"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <el-text-field
                      label="Vykdytojas"
                      tooltip="Paieška. Savitarnos paieškos. Vykdytojas"
                      v-model="extraData.tvirtintojas"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <el-text-field
                      label="PAS numeris"
                      tooltip="Paieška. Savitarnos paieškos. PAS numeris"
                      v-model="extraData.uzs_paslaugos_pra_id"
                    />
                  </v-col>
                  <v-col cols="12" md="12">
                    <el-text-field
                      label="Užsakymo parametrai"
                      tooltip="Paieška. Savitarnos paieškos. Užsakymo parametrai"
                      v-model="extraData.pai_parametrai"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-row no-gutters>
            <v-col cols="12">
              <el-button
                primary
                :loading="loading"
                @click.native.stop="searchData()"
              >
                Ieškoti
              </el-button>
              <el-button :loading="loading" @click.native="clearData()">
                Išvalyti
              </el-button>
            </v-col>
          </v-row>
        </form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PaieskaTvirtinimasSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    mainData: {},
    extraData: {
      pai_tipas: null,
      pai_numeris: null,
      uzs_paslaugos_pra_id: null,
      pai_busenos: [],
      pai_apimtis: null,
      pai_sukure: null,
      pai_sukurimo_data_nuo: null,
      pai_sukurimo_data_iki: null,
      mano_darbai: true,
    },
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      return this.searchPanel === 0
    },
    paieskaTipasList() {
      return [
        { value: 'juridinis', text: 'Pagal juridinį asmenį' },
        { value: 'fizinis', text: 'Pagal fizinį asmenį' },
        { value: 'turtas', text: 'Pagal turtą' },
        { value: 'kodas', text: 'Pagal identifikavimo kodą' },
        { value: 'pazyma', text: 'Pažyma apie ŽŪ / MŪ paskirties žemes' },
        { value: 'sklypas', text: 'Žemės sklypo planas' },
      ]
    },
    paieskaBusenaList() {
      return [
        { value: 'laukia_patvirtinimo', text: 'Laukia patvirtinimo' },
        { value: 'tikrinama', text: 'Tikrinamas' },
        { value: 'laukia_apmokejimo', text: 'Laukia apmokėjimo' },
        { value: 'vykdoma', text: 'Vykdomas' },
        { value: 'ivykdyta', text: 'Įvykdytas' },
        { value: 'neivykdyta', text: 'Neįvykdytas' },
        { value: 'atmesta', text: 'Atmestas' },
      ]
    },
    paieskaApimtisList() {
      return [
        { value: 1, text: 'Sąrašas' },
        { value: 2, text: 'Patikra' },
        { value: 3, text: 'Išrašas' },
        { value: 4, text: 'Pažyma' },
        { value: 5, text: 'Planas' },
      ]
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    if (this.searchParams && this.searchParams.route === this.$route.name) {
      this.mainData = this.searchParams.mainData
      this.extraData = this.searchParams.extraData
      this.searchPanel = this.searchParams.isExpanded ? 0 : null
    }
    this.checkGautaPaslauga()
  },
  methods: {
    searchData() {
      let searchData = {
        ...this.extraData,
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.extraData = {
        pai_tipas: null,
        pai_numeris: null,
        uzs_paslaugos_pra_id: null,
        pai_busenos: [],
        pai_apimtis: null,
        pai_sukure: null,
        pai_sukurimo_data_nuo: null,
        pai_sukurimo_data_iki: null,
        mano_darbai: false,
      }
    },
    submit() {
      this.searchData()
    },
    checkGautaPaslauga() {
      const gautasPranesimas = sessionStorage.getItem('gautasPranesimas')

      if (!(gautasPranesimas && gautasPranesimas.length > 0)) {
        this.searchData()
        return
      }

      sessionStorage.setItem('gautasPranesimas', '')

      const data = { pranesimas_numeris: gautasPranesimas }
      this.$axios
        .post(`pranesimas-numeris`, data)
        .then(res => {
          const pazymaID = res.data.zurnalas.paz_id
          if (pazymaID) {
            this.extraData.pai_pas_numeris = pazymaID
            this.searchPanel = 0
          }
        })
        .finally(() => {
          this.searchData()
        })
    },
  },
}
</script>
